import { Box, Grid, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { ApiError } from "../../Api/ApiError";
import { SearchCustomer, SearchCustomerProps } from "../../Api/Customer";
import { CustomerInterface } from "../../Objects/Customer";
import CustomerCard from "../molecules/CustomerCard";
import CustomerSearchForm from "../molecules/CustomerSearchForm";

export interface SelectCustomerAreaProps {
    onSelect?: (customerData: CustomerInterface) => void
}

const SelectCustomerArea: React.FC<SelectCustomerAreaProps> = ({
    onSelect
}) => {
    const DISPLAY_ROWS = 6

    let [searchStrings, setSearchStrings] = React.useState("")
    let [searchProps, setSearchProps] = React.useState<SearchCustomerProps>()
    let [customers, setCustomers] = React.useState<CustomerInterface[]>()
    let { enqueueSnackbar } = useSnackbar()

    React.useEffect(() => {
        const controller = new AbortController()
        if (searchProps) {
            SearchCustomer(searchProps, {signal: controller.signal}).then(({ list, rows }) => {
                setCustomers(list)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }
        return () => {
            controller.abort()
        }
    }, [searchProps, enqueueSnackbar])

    return (
        <>
            <Box>
                <Grid container
                    maxWidth={600}
                >
                    <Grid item>
                        <Typography >会員情報から検索：</Typography>
                    </Grid>
                    <Grid item xs>
                        <CustomerSearchForm
                            searchStrings={searchStrings}
                            onChange={e => {
                                setSearchStrings(e.target.value)
                            }}
                            onSearch={() => {
                                setSearchProps({
                                    searchStr: searchStrings,
                                    // accessKey: "HEAD-OFFICE_LOGIN",
                                    page: 1,
                                    num: DISPLAY_ROWS
                                })
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
            {customers &&
                <Grid container sx={{ padding: "0 14px 14px 14px", marginTop: "14px" }} spacing={2}>
                    {customers.map(customer => (
                        <Grid item key={customer.ctm_id} xs={12} sm={6} md={4}>
                            <CustomerCard
                                customer={customer}
                                onClick={ctmData => {
                                    if( onSelect ) {
                                        onSelect(ctmData)
                                    }
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            }
        </>
    )
}

export default SelectCustomerArea